// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__zCH7-","overflowing":"ReadFullNote_overflowing__3ijG_"};